var map = {
	"./1.png": 7929,
	"./10.png": 9469,
	"./11.png": 9524,
	"./12.png": 4175,
	"./2.png": 7218,
	"./3.png": 5083,
	"./4.png": 3428,
	"./5.png": 9725,
	"./6.png": 8102,
	"./7.png": 8079,
	"./8.png": 3435,
	"./9.png": 33
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4689;